// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"Button_styledButton__1zcLM","alt":"Button_alt__31fUr","disabledBtn":"Button_disabledBtn__1Rxd6","spinner":"Button_spinner__2dyf5"};